"use client";

import { useUser } from "@clerk/nextjs";
import { CheckIcon } from "@heroicons/react/24/outline";

import { RequiredBuyPremiumButton } from "@/app/_components/required/buy-premium-button";

import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";

import { defaultEmptyText, modalityCriteria } from "@/constants";
import { modalitySearchParam, filterSearchParam } from "@/filters";

import { cn } from "@/lib/utils";
import { getUserPlanByMetadata } from "@/helper/user/client";

import { useFilter } from "../use-filter";

interface Props {
  hideSearchInput?: boolean;
}

export function Modality({ hideSearchInput }: Props) {
  const [{ modalidade }, setSearchParam] = useFilter();
  const { user } = useUser();
  const { hasPaidPlan } = getUserPlanByMetadata(user?.publicMetadata);

  return (
    <Command>
      {!hideSearchInput ? <CommandInput placeholder="Buscar..." /> : null}
      <CommandList className="px-1">
        <CommandEmpty>{defaultEmptyText}</CommandEmpty>
        <RequiredBuyPremiumButton>
          <CommandGroup>
            {modalitySearchParam.map((key) => {
              const isSelected = modalidade.includes(key);
              const label = modalityCriteria[key];

              return (
                <CommandItem
                  key={key}
                  onSelect={() => {
                    if (hasPaidPlan) {
                      const length = modalidade.length;

                      if (length) {
                        if (length === 1 && isSelected) {
                          return setSearchParam({
                            [filterSearchParam.modalidade]: null,
                          });
                        }

                        setSearchParam({
                          [filterSearchParam.modalidade]: isSelected
                            ? modalidade.filter((item) => item !== key)
                            : [...modalidade, key],
                        });
                      } else {
                        setSearchParam({
                          [filterSearchParam.modalidade]: [key],
                        });
                      }
                    }
                  }}
                >
                  <div
                    className={cn(
                      "mr-2 flex size-4 items-center justify-center rounded-[4px] border border-primary",
                      isSelected
                        ? "bg-primary text-primary-foreground"
                        : "opacity-50 [&_svg]:invisible"
                    )}
                  >
                    <CheckIcon className="size-4" />
                  </div>
                  <span>
                    {key === "1" || key === "2" ? `${label} (à vista)` : label}
                  </span>
                </CommandItem>
              );
            })}
          </CommandGroup>
        </RequiredBuyPremiumButton>
      </CommandList>
    </Command>
  );
}
